var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"b3c4f5b530900d579e152bd22c0b9c0f83c4aa0d"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["nmh@try-apt-as"]={id:"b3c4f5b530900d579e152bd22c0b9c0f83c4aa0d"};
      